(() => {
  class HeaderImageSearch extends HTMLElement {
    #listeners;
    #bindings;
    #mobile = window.matchMedia('(max-width: 748px)');

    async connectedCallback() {
      if (this.#listeners) return;
      this.#listeners = new AbortController();
      const signal = this.#listeners.signal;
      await Promise.all([
        customElements.whenDefined('predictive-search-drawer'),
        customElements.whenDefined('image-search'),
      ]);
      if (signal.aborted) return;
      // Focal はドロワーを再描画時に別ノードへ差し替えるため、セクション読み込みごとに繋ぎ直す。
      document.addEventListener('shopify:section:load', () => this.#bind(), { signal });
      this.#bind();
    }

    #bind() {
      const drawer = document.getElementById('search-drawer');
      const trigger = drawer?.querySelector('[data-image-search-trigger]');
      if (!trigger || drawer === this.drawer) return;
      this.#release();
      this.#bindings = new AbortController();
      const signal = this.#bindings.signal;
      this.drawer = drawer;
      this.trigger = trigger;
      this.panel = this.querySelector('dialog');
      this.search = this.panel.querySelector('image-search');
      const options = { signal };
      this.trigger.addEventListener('click', () => this.#open(), options);
      this.panel.querySelector('[data-image-change]').addEventListener('click', () => {
        this.#chooseImage();
      }, options);
      this.panel.querySelector('[data-image-close]').addEventListener('click', () => {
        this.panel.close();
      }, options);
      // 全画面になるモバイル以外では、背景のクリックでも閉じる。
      // 押した位置も見て、ダイアログ内から始まったドラッグで閉じないようにする。
      let pressedBackdrop = false;
      this.panel.addEventListener('pointerdown', (event) => {
        pressedBackdrop = event.target === this.panel;
      }, options);
      this.panel.addEventListener('click', (event) => {
        if (pressedBackdrop && event.target === this.panel && !this.#mobile.matches) this.panel.close();
      }, options);
      this.search.addEventListener('image-search:state', (event) => {
        this.panel.classList.toggle('is-searched', event.detail.searched);
      }, options);
      this.panel.addEventListener('close', () => {
        this.search.reset.click();
        if (this.drawer.hasAttribute('open')) {
          this.drawer.focusTrap.unpause();
          // Focal のフォーカス復帰処理が終わってから画像検索ボタンへ戻す。
          setTimeout(() => {
            if (this.isConnected && !this.panel.open && this.drawer.hasAttribute('open')) this.trigger.focus();
          }, 0);
        }
      }, options);
      this.search.form.addEventListener('submit', () => this.search.query.blur(), options);
      window.addEventListener('pagehide', () => this.search.cancel(), options);
      window.addEventListener('pageshow', (event) => {
        if (event.persisted && this.panel.open) this.search.search(this.search.query.value);
      }, options);
      // 途中で失敗したときに押せる見た目にしないよう、繋ぎ終えてから表示する
      this.trigger.hidden = false;
    }

    disconnectedCallback() {
      this.#release();
      this.#listeners?.abort();
      this.#listeners = null;
    }

    #release() {
      if (!this.drawer) return;
      if (this.panel?.open) {
        this.drawer.focusTrap.unpause();
        this.panel.close();
      }
      this.#bindings?.abort();
      this.#bindings = null;
      this.drawer = null;
    }

    #open() {
      if (this.panel.open) return;
      // 通常検索を保持し、結果 dialog のネイティブなフォーカス制御に切り替える。
      if (this.drawer.hasAttribute('open')) this.drawer.focusTrap.pause();
      // 自分でフォーカスを移すと、タップで開いただけでも :focus-visible になる環境がある
      this.panel.showModal();
      this.panel.querySelector('[data-image-content]').scrollTop = 0;
    }

    #chooseImage() {
      this.search.file.value = '';
      this.search.file.click();
    }

  }

  if (!customElements.get('header-image-search')) {
    customElements.define('header-image-search', HeaderImageSearch);
  }
})();
